// import { Button , Checkbox } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
// import { FxInput, FxSelect, http, AlertService, localstorage } from '../../../fx-core';
import { FxInput, FxSelect, http, AlertService, localstorage, session, general, formatService } from '../../../fx-core';
import { Checkbox, Button, Link } from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import './NewCategoryItemForm.scss';
import _ from "lodash";

const NewCategoryItemForm = (props) => {
  const defaultItem = {
    serviceId: props.serviceId,
    communityId: parseInt(localstorage.getItem("communityId")),
    categoryId: props.selectedCategoryId !== undefined && props.selectedCategoryId !== null
    ? parseInt(props.selectedCategoryId, 10)
    : 0,
    categoryName: props.selectedCategoryName || "",
    itemId: 0,
    itemName: "",
    otherCategory: "",
    newSubCategory: "",
    newSpecificCategory: ""
  };

  const [item, setItem] = useState(defaultItem);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState('');
  const [showNewSubCategoryInput, setShowNewSubCategoryInput] = useState(false);

  const [specificCategories, setSpecificCategories] = useState([]);
  const [selectedSpecificCategoryId, setSelectedSpecificCategoryId] = useState('');
  const [showNewSpecificCategoryInput, setShowNewSpecificCategoryInput] = useState(false);

    // new: locally created items (show inside the form)
  const [createdItems, setCreatedItems] = useState([]);
  const [localIdCounter, setLocalIdCounter] = useState(0);

   const [confirmAccept, setConfirmAccept] = useState(false);
  const [confirmProcessing, setConfirmProcessing] = useState(false);


  const selectedCreatedItems = createdItems.filter(ci => !!ci.isSelected);

   const handleConfirmAccept = (e) => {
    setConfirmAccept(Boolean(e.target.checked));
  };

  const collectServiceRequestDetailsForForm = () => {
    return selectedCreatedItems.map(ci => ({
      itemId: ci.itemId,
      itemName: ci.itemName,
      categoryId: ci.categoryId,
      categoryName: ci.categoryName
    }));
  };

  const submitServiceRequestFromForm = async () => {
    if (!confirmAccept) {
      AlertService.showMsg({ message: "Please agree provider agreement" });
      return;
    }

    // build service request object (use serviceId from item/service state or props)
    const serviceIdToUse = item.serviceId || props.serviceId || 0;
    const communityIdToUse = item.communityId || parseInt(localstorage.getItem("communityId") || '0');
    const stallIdToUse = (props.stallId !== undefined && props.stallId !== null) ? props.stallId : 0;

    const serviceRequest = {
      serviceId: serviceIdToUse,
      communityId: communityIdToUse,
      serviceRequestType: props.serviceRequestType || "Sell", // adjust if you need a specific request type
      stallId: stallIdToUse,            // if you have stallId, set it; otherwise 0
      currentDate: formatService.getCurrentDateForServer()
    };

    const serviceRequestDetails = collectServiceRequestDetailsForForm();
    const inputData = {
      
      ServiceRequest: serviceRequest,
      ServiceRequestDetails: serviceRequestDetails
    };

    try {
      setConfirmProcessing(true);
      const apiOptions = { url: `servicerequest/save`, data: inputData };
      const res = await http.post(apiOptions);
      const result = res.data;
      // success
      AlertService.showSuccessMsg("Your service request is confirmed");
      // clear locally stored items (you used session.otherCategoryItems previously)
      session.setItem('otherCategoryItems', JSON.stringify([]));
      // clear this form's created items and selection
      setCreatedItems([]);
      setConfirmAccept(false);
      
       if (props.onSaveFormCallback) {
    props.onSaveFormCallback({ submitted: true, serviceReqId: result.serviceReqId, subscriptionStatus: result.subscriptionStatus });
  }

  // CLOSE the drawer/form now that submit succeeded
  if (props.handleFormClose) {
    props.handleFormClose();
  }
      // props.onSaveFormCallback && props.onSaveFormCallback({ submitted: true, serviceReqId: result.serviceReqId, subscriptionStatus: result.subscriptionStatus });
    } catch (err) {
      console.error('submitServiceRequestFromForm failed', err);
      AlertService.showErrorMsg && AlertService.showErrorMsg("Failed to submit service request");
    } finally {
      setConfirmProcessing(false);
    }
  };

  // Handle item change
  const handleItemChange = (data) => {
    setItem(prevState => ({ ...prevState, ...data }));
  };

  // Fetch main categories
  const getCategories = () => {
    let inputData = {
      communityId: item.communityId,
      serviceId: props.serviceId
    };
    http.post({ url: `category/active`, data: inputData })
      .then(res => {
        let resData = res.data || {};
        let categoryList = [];
        let otherCategory = {
          communityId: item.communityId,
          serviceId: item.serviceId,
          id: -1,
          categoryName: "New Category"
        };
        if (resData.categories && resData.categories.length > 0) {
          resData.categories.push(otherCategory);
          categoryList = resData.categories;
        } else {
          categoryList.push(otherCategory);
        }
        setCategories(categoryList);

    const incomingCatId = props.selectedCategoryId !== undefined && props.selectedCategoryId !== null
      ? parseInt(props.selectedCategoryId, 10)
      : null;

    if (incomingCatId !== null) {
      // if incoming category exists in the list, select it; otherwise fallback to first
      const matched = categoryList.find(c => (c.id === incomingCatId || c.Id === incomingCatId || c.categoryId === incomingCatId));
      if (matched) {
        handleItemChange({ categoryId: matched.id, categoryName: matched.categoryName || matched.CategoryName || props.selectedCategoryName || "" });
        fetchSubCategories(matched.id);
      } else {
        // fallback to first element
        handleItemChange({ categoryId: categoryList[0].id, categoryName: categoryList[0].categoryName });
      }
    } else {
      handleItemChange({ categoryId: categoryList[0].id, categoryName: categoryList[0].categoryName });
    }

      });
  };

  // Fetch subcategories for category
  const fetchSubCategories = (categoryId) => {
    if (!categoryId || categoryId < 1) {
      setSubCategories([]);
      setSelectedSubCategoryId('');
      setShowNewSubCategoryInput(false);
      setSpecificCategories([]);
      setSelectedSpecificCategoryId('');
      setShowNewSpecificCategoryInput(false);
      return;
    }
    http.post({
      url: "category/SubCategory",
      data: { CategoryId: categoryId }
    }).then(res => {
      let mappedSubCategories = (res.data.subCategories || []).map(x => ({
        ...x,
        id: x.id || x.subCategoryId,
        name: x.name
      }));
      setSubCategories(mappedSubCategories);
      setSelectedSubCategoryId('');
      setShowNewSubCategoryInput(false);
      setSpecificCategories([]);
      setSelectedSpecificCategoryId('');
      setShowNewSpecificCategoryInput(false);
    });
  };

  // Fetch specific categories for subcategory
  const fetchSpecificCategories = (subCategoryId) => {
    if (!subCategoryId || subCategoryId < 1) {
      setSpecificCategories([]);
      setSelectedSpecificCategoryId('');
      setShowNewSpecificCategoryInput(false);
      return;
    }
    http.post({
      url: "category/SpecificCategory",
      data: { subCategoryId: subCategoryId }
    }).then(res => {
      let mapped = (res.data.specificCategory || []).map(x => ({
        ...x,
        id: x.id || x.specificCategoryId,
        name: x.name
      }));
      setSpecificCategories(mapped);
      setSelectedSpecificCategoryId('');
      setShowNewSpecificCategoryInput(false);
    });
  };

  // Category change handler
  // const handleCategoryChange = (item) => {
  //   handleItemChange({ categoryId: item.value, newSubCategory: "", newSpecificCategory: "" });
  //   fetchSubCategories(item.value);
  //   setSelectedSubCategoryId('');
  //   setShowNewSubCategoryInput(false);
  //   setSelectedSpecificCategoryId('');
  //   setShowNewSpecificCategoryInput(false);
  // };

    // Category change handler
  const handleCategoryChange = (sel) => {
    const selId = sel.value;
    // attempt to resolve category name from provided options
    const matched = (categories || []).find(c => (c.id === selId || c.Id === selId || c.categoryId === selId));
    const resolvedName = matched ? (matched.categoryName || matched.CategoryName || matched.name || '') : '';

    handleItemChange({ 
      categoryId: selId, 
      categoryName: resolvedName,
      newSubCategory: "", 
      newSpecificCategory: "" 
    });

    fetchSubCategories(selId);
    setSelectedSubCategoryId('');
    setShowNewSubCategoryInput(false);
    setSelectedSpecificCategoryId('');
    setShowNewSpecificCategoryInput(false);
  };


  // Subcategory change handler
  const handleSubCategoryChange = (item) => {
    setSelectedSubCategoryId(item.value);
    handleItemChange({ newSubCategory: "", newSpecificCategory: "" });
    fetchSpecificCategories(item.value);
    setSelectedSpecificCategoryId('');
    setShowNewSpecificCategoryInput(false);
  };

  // Specific category change handler
  const handleSpecificCategoryChange = (item) => {
    setSelectedSpecificCategoryId(item.value);
    handleItemChange({ newSpecificCategory: "" });
  };

  // Normal input change
  const handleInputChange = (item) => {
    handleItemChange({ [item.name]: item.value });
  };

  const toggleCreatedItemSelect = (localUid) => {
  setCreatedItems(prev =>
    prev.map(ci =>
      ci.localUid === localUid
        ? { ...ci, isSelected: !ci.isSelected }
        : ci
    )
  );
};



  // Save form handler (async for DB save)
  const saveForm = async () => {
    if (item.categoryId == -1 && !item.otherCategory) {
      AlertService.showMsg({ message: "Please select Other Category" });
      return;
    }
    if (showNewSubCategoryInput && !item.newSubCategory) {
      AlertService.showMsg({ message: "Please enter a new Sub Category" });
      return;
    }
    if (showNewSpecificCategoryInput && !item.newSpecificCategory) {
      AlertService.showMsg({ message: "Please enter a new Specific Category" });
      return;
    }
    if (!item.itemName) {
      AlertService.showMsg({ message: "Please enter Item" });
      return;
    }
    if (item.categoryId !== -1) {
      handleItemChange({ otherCategory: "" });
    }

    let subCategoryIdToUse = selectedSubCategoryId;
    let specificCategoryIdToUse = selectedSpecificCategoryId;

    // 1. Add new subcategory if needed
    if (showNewSubCategoryInput && item.newSubCategory) {
      const subCatRes = await http.post({
        url: "category/SubCategory",
        data: {
          categoryId: item.categoryId,
          name: item.newSubCategory
        }
      });
      // Try to get the new one
      const subCats = (subCatRes.data.subCategories || []);
      const newSub = subCats.find(x => x.name === item.newSubCategory);
      if (newSub) subCategoryIdToUse = newSub.id || newSub.subCategoryId;
    }

    // 2. Add new specific category if needed
    if (showNewSpecificCategoryInput && item.newSpecificCategory && subCategoryIdToUse) {
      const specCatRes = await http.post({
        url: "category/SpecificCategory",
        data: {
          subCategoryId: subCategoryIdToUse,
          name: item.newSpecificCategory
        }
      });
      const specCats = (specCatRes.data.specificCategory || []);
      const newSpec = specCats.find(x => x.name === item.newSpecificCategory);
      if (newSpec) specificCategoryIdToUse = newSpec.id || newSpec.specificCategoryId;
    }

    const genLocalId = `local-${Date.now()}-${localIdCounter}`;
    setLocalIdCounter(c => c + 1);

    // resolve category name robustly (use otherCategory if categoryId === -1)
    let resolvedCategoryName = '';
    if (item.categoryId === -1) {
      resolvedCategoryName = item.otherCategory || item.categoryName || '';
    } else {
      resolvedCategoryName =
        item.categoryName ||
        (_.find(categories, { id: item.categoryId })?.categoryName) ||
        (_.find(categories, { id: item.categoryId })?.name) ||
        '';
    }

    let categoryItemDetail = [{
      categoryId: item.categoryId,
      categoryName: resolvedCategoryName,
      subCategoryId: subCategoryIdToUse,
      subCategoryName: showNewSubCategoryInput ? item.newSubCategory : _.find(subCategories, { id: subCategoryIdToUse })?.name,
      specificCategoryId: specificCategoryIdToUse,
      specificCategoryName: showNewSpecificCategoryInput ? item.newSpecificCategory : _.find(specificCategories, { id: specificCategoryIdToUse })?.name,
      // use generated unique local id instead of fixed -1
      itemId: -1,
      localUid: genLocalId,
      itemName: item.itemName
    }];

    // notify parent (parent can persist to session or ignore; it will no longer close)
    props.onSaveFormCallback({
      otherCategoryItems: categoryItemDetail
    });
    

    // Append to this form's local createdItems list (avoid duplicates by itemName+categoryName)
    setCreatedItems(prev => {
      const next = [...prev];
      for (const ci of categoryItemDetail) {
        const dup = next.find(x => (x.itemName === ci.itemName && (x.categoryName || '') === (ci.categoryName || '')));
        if (!dup) {
          next.unshift({
            ...ci,
            isSelected: false   // default unchecked
          });
        }
      }
      return next;
    });
    

    // Reset item input so user can add another quickly
    setItem(prev => ({
      ...prev,
      itemId: 0,
      itemName: '',
      otherCategory: '',        // clear New Category textbox
      newSubCategory: '',
      newSpecificCategory: ''
    }));
    setSelectedSubCategoryId('');
    setShowNewSubCategoryInput(false);
    setSelectedSpecificCategoryId('');
    setShowNewSpecificCategoryInput(false);

  };

  const handleClose = () => {
    props.handleFormClose();
  };

  useEffect(() => {
    getCategories();
  }, []);

  // ---- UI -----
  return (
    <div className='newcatgitem-form-ui'>
      <div className='row title-font py-1 justify-content-between px-2 drawer-header'>
        <span className="col-11">
          <span>New Form</span>
        </span>
        <span className="col-1 text-center">
          <i className="fas fa-times-circle font-16 pointer" onClick={handleClose}></i>
        </span>
      </div>
    <div className="form-body">
      <div className="m-4 pt-4 pb-5">
        <div className="m-1 pt-3">
          <FxSelect
            name="categoryId"
            variant="outlined"
            label="Category"
            options={categories}
            selectedValue={item.categoryId}
            valueField="id"
            displayField="categoryName"
            size="small"
            fullWidth
            onValueChange={handleCategoryChange}
          />
        </div>

        {/* <div className="m-1 pt-3">
          <FxSelect
            name="subCategoryId"
            variant="outlined"
            label="Sub Category (optional)"
            options={subCategories.length > 0 ? [{ id: '', name: 'None' }, ...subCategories] : [{ id: '', name: 'None' }]}
            selectedValue={selectedSubCategoryId}
            valueField="id"
            displayField="name"
            size="small"
            fullWidth
            onValueChange={handleSubCategoryChange}
          />
          <div className="mt-2">
            {!showNewSubCategoryInput && (
              <Button
                variant="outlined"
                size="small"
                onClick={() => { setShowNewSubCategoryInput(true); setSelectedSubCategoryId(''); }}
              >
                + Add New Sub Category
              </Button>
            )}
            {showNewSubCategoryInput && (
              <FxInput
                name="newSubCategory"
                variant="outlined"
                label="New Sub Category"
                fullWidth
                value={item.newSubCategory}
                onValueChange={handleInputChange}
                className="mt-2"
              />
            )}
          </div>
        </div>

        <div className="m-1 pt-3">
          <FxSelect
            name="specificCategoryId"
            variant="outlined"
            label="Specific Category (optional)"
            options={specificCategories.length > 0 ? [{ id: '', name: 'None' }, ...specificCategories] : [{ id: '', name: 'None' }]}
            selectedValue={selectedSpecificCategoryId}
            valueField="id"
            displayField="name"
            size="small"
            fullWidth
            onValueChange={handleSpecificCategoryChange}
          />
          <div className="mt-2">
            {!showNewSpecificCategoryInput && (
              <Button
                variant="outlined"
                size="small"
                onClick={() => { setShowNewSpecificCategoryInput(true); setSelectedSpecificCategoryId(''); }}
              >
                + Add New Specific Category
              </Button>
            )}
            {showNewSpecificCategoryInput && (
              <FxInput
                name="newSpecificCategory"
                variant="outlined"
                label="New Specific Category"
                fullWidth
                value={item.newSpecificCategory}
                onValueChange={handleInputChange}
                className="mt-2"
              />
            )}
          </div>
        </div> */}

        <div className="m-1 pt-3">
          {item.categoryId == -1 &&
            <FxInput name="otherCategory" variant="outlined" label="New Category" fullWidth
              value={item.otherCategory} onValueChange={handleInputChange} />
          }
        </div>

        {/* <div className="m-1 pt-3">
          <FxInput name="itemName" variant="outlined" label="Item" fullWidth
            value={item.itemName} onValueChange={handleInputChange} />
        </div> */}
         <div className="m-1 pt-3 item-input-row">
          <div className="item-input-field" style={{ flex: 1 }}>
            <FxInput
              name="itemName"
              variant="outlined"
              label="Item"
              fullWidth
              value={item.itemName}
              onValueChange={handleInputChange}
            />
          </div>

          <div className="item-add-button" style={{ marginLeft: 8 }}>
            <Button
              type="button"
              variant="contained"
              size="medium"
              color="primary"
              onClick={saveForm}
            >
              Add
            </Button>
          </div>
        </div>
      </div>
      {/* show locally created items inside the drawer */}
        {createdItems.length > 0 && (
          <div className="m-1 mb-3 created-items-list">
            <div className="font-14 mb-2"><b>Created Items</b></div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {createdItems.map((ci, idx) => (
                <div key={`${ci.localUid}-${idx}`} className="created-item-card">

                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <Checkbox
                      checked={!!ci.isSelected}
                      onChange={() => toggleCreatedItemSelect(ci.localUid)}
                      size="small"
                      inputProps={{ 'aria-label': `select-${ci.localUid}` }}
                    />
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600 }}>{ci.itemName}</div>
                      <div style={{ fontSize: 12, color: '#666' }}>{ci.categoryName || 'No category'}</div>
                    </div>
                  </div>

                  <div style={{ paddingLeft: 12 }}>
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => {
                        // remove single created item from the form list
                        setCreatedItems(prev => prev.filter(x => x.localUid !== ci.localUid));

                      }}
                      style={{ color: '#d9534f', textDecoration: 'none', cursor: 'pointer' }}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {/* Confirmation panel for selected created items */}
        

</div>
{selectedCreatedItems.length > 0 && (
          <div className="m-1 mt-3 confirm-panel" style={{ borderTop: '1px solid #eee', paddingTop: 12 }}>
            

            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <span className='pr-1 color-grey'><i className="fas fa-info-circle"></i></span>
              <span className='color-grey pr-1'>Please read all details from</span>
              <span>
                <Link className="pointer" onClick={() => { const url = general.getProviderAgreementUrl(); if (url) window.open(url, '_blank'); }}>
                  Provider Agreement
                </Link>
              </span>
            </div>

            <div style={{ marginBottom: 12 ,alignItems: 'center', display: 'flex' }}>
              <Checkbox
                name="confirmAccept"
                color="primary"
                checked={confirmAccept}
                onChange={handleConfirmAccept}
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
              />
              <span className="ml-1">I agree</span>
            </div>

            <div className="confirm-actions">

              <Button variant="contained" size="small" onClick={() => {
                // simply clear selection (Back)
                setCreatedItems(prev => prev.map(ci => ({ ...ci, isSelected: false })));
                setConfirmAccept(false);
              }}>
                Back
              </Button>

              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={submitServiceRequestFromForm}
                disabled={confirmProcessing}
              >
                {confirmProcessing ? 'Submitting...' : 'Submit'}
              </Button>
            </div>
          </div>
        )}
        {/* <div style={{ paddingLeft: 12, paddingRight: 12, paddingBottom:8,paddingTop:4 }}>
          <Button  type="button" variant="contained" size="medium" color="primary" fullWidth onClick={saveForm}>
            Add
          </Button>
        </div> */}
</div>
      
    
  );
};

export default NewCategoryItemForm;
